import React from "react";
import { Checkbox, Box } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

interface Props {
  handleChange: any;
  label: string;
  value?: boolean;
  error?: any;
  name?: string;
  marginTop?: number;
  marginRight?: number;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    // formControl: {
    //   margin: theme.spacing(3),
    // },
  })
);

export default function CommonCheckBox({
  handleChange,
  label,
  value,
  error,
  name,
  marginTop,
  marginRight,
}: Props) {
  const classes = useStyles();
  return (
    <Box className={classes.root} mt={marginTop || 0} mr={marginRight || 0}>
      <FormControl error={error} component="fieldset">
        <FormControlLabel
          control={
            <Checkbox
              checked={value || false}
              onChange={handleChange}
              name={name}
              color={"primary"}
            />
          }
          label={label}
        />
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Box>
  );
}
